var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7658 2.58558L28 0.464316V0H20.2603L14.7443 13.6261L8.46883 0H0.3535V0.464316L2.96333 3.58253C3.21767 3.81295 3.35067 4.14989 3.31683 4.48916V16.7432C3.39733 17.1843 3.25267 17.6382 2.94 17.9589L0 21.4952V21.9537H8.33583V21.4894L5.39583 17.9589C5.07733 17.6371 4.92683 17.1913 4.991 16.7432V6.14379L12.3083 21.9595H13.1588L19.4507 6.14379V18.7428C19.4507 19.0752 19.4507 19.1435 19.2313 19.3612L16.968 21.5345V22H27.9487V21.5357L25.767 19.4156C25.5757 19.272 25.4765 19.0312 25.5173 18.7973V3.20389C25.4765 2.96884 25.5745 2.728 25.7658 2.58558Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic_medium.377e46a4a9f47d22504e80661ef0661c.svg";
export { ForwardRef as ReactComponent };